<template>
  <r-button
    class="r-delete-button"
    :mini="tiny"
    :class="{ cross, angular, transparent }"
    :disabled="disabled"
    type="danger"
    :simple="!!cross"
    bold
    :icon="{
      name: cross ? 'close-delete' : 'trash',
      size: tiny ? 18 : 22,
      color: 'var(--accent-danger)'
    }"
    @click="beforeDelete($event)"
  >
    <span
      v-if="!mini && !tiny"
      class="r-delete-button__text"
    >
      {{ label || $t('r-delete') }}
    </span>
  </r-button>
</template>

<script>
export default {
  props: {
    mini: {
      type: Boolean,
      default: () => false
    },
    tiny: {
      type: Boolean,
      default: () => false
    },
    cross: {
      type: Boolean,
      default: () => false
    },
    simple: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    angular: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async beforeDelete(event) {
      this.$emit('click', event)
      if (this.disabled) return
      if (this.simple) {
        this.$emit('delete', event)
      } else if (
        await this.$dialog({
          title: this.$t('r-delete:info'),
          message: this.$t('r-delete:question'),
          controls: {
            yes: {
              text: this.$t('r-delete'),
              icon: 'trash',
              type: 'danger'
            },
            no: {
              text: this.$t('no'),
              type: 'simple'
            }
          }
        })
      ) {
        this.$emit('delete', event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.r-delete-button {
  background: $accent-danger-hover;

  &.angular {
    border-radius: 0;
  }

  &.cross,
  &.transparent {
    background-color: transparent;

    &:hover {
      background-color: transparent !important;
    }
  }

  &__text {
    color: $accent-danger !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "r-delete": "Удалить",
    "r-delete:info": "Объект будет удален безвозвратно",
    "r-delete:question": "Удалить объект?"
  },
  "en": {
    "r-delete": "Delete",
    "r-delete:info": "The object will be permanently deleted",
    "r-delete:question": "Delete object?"
  }
}
</i18n>
